import { FETCH_PSGENERIC } from "../../actions/types";

const INITIAL_STATE = {
  events: []
};

const genericReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PSGENERIC:
      return payload.data;
    default:
      return state;
  }
};

export default genericReducer;



// WEBPACK FOOTER //
// ./src/reducers/helpers/generic_reducer.js